import { createContext } from "react";

import { defaultWhitelabelBrand, type WhitelabelBrand } from "@/configs/whitelabel";

export const WhitelabelBrandContext = createContext<WhitelabelBrand>(defaultWhitelabelBrand);
